import { IFieldType, IAutocomplete, ITheme, IFormButtons, IFormFields } from "shared/types";
import { copy } from "shared/assets";
import { Marker } from "shared/assets/icons";
import { StyledAddressButton } from "./styles";
import { ChangeEvent } from "react";

const { venueProperties, createVenue, errors } = copy;

export const getFields = (
  handleChange: ({ value, name }: { value: string; name: string }) => void
): IFormFields => {
  const handleInputChange = ({ target }: ChangeEvent<HTMLInputElement>) =>
    handleChange({ name: target.name, value: target.value });

  return [
    {
      name: "addressLine1",
      label: venueProperties.addressLine1.title,
      type: IFieldType.text,
      autocomplete: IAutocomplete.addressLine1,
      validation: {
        required: errors.required,
      },
      note: venueProperties.addressLine1.note,
      onChange: handleInputChange,
    },
    {
      name: "addressLine2",
      label: venueProperties.addressLine2.title,
      autocomplete: IAutocomplete.addressLine2,
      type: IFieldType.text,
      note: venueProperties.addressLine2.note,
      onChange: handleInputChange,
    },
    {
      name: "city",
      label: venueProperties.city.title,
      type: IFieldType.text,
      validation: {
        required: errors.required,
      },
      onChange: handleInputChange,
    },
    {
      name: "zip",
      label: venueProperties.zip.title,
      type: IFieldType.text,
      autocomplete: IAutocomplete.postalCode,
      validation: {
        required: errors.required,
      },
      onChange: handleInputChange,
    },
    {
      name: "state",
      label: venueProperties.state.title,
      type: IFieldType.text,
      onChange: handleInputChange,
    },
    {
      name: "country",
      label: venueProperties.country.title,
      type: IFieldType.country,
      autocomplete: IAutocomplete.country,
      validation: {
        required: errors.required,
      },
      onChange: (data?: { value: string }) =>
        data?.value && handleChange({ value: data.value, name: "country" }),
    },
  ];
};

export const buttons: IFormButtons = {
  primary: {
    children: (
      <StyledAddressButton>
        <Marker key="marker" />
        <span key="label">{createVenue.submit.address}</span>
      </StyledAddressButton>
    ),
    theme: ITheme.tertiary,
    isFullWidthMobile: true,
  },
};
